import _ from 'lodash'
import arrayStream from 'stream-array'
import Chunker from 'scoreboard/components/chunker'

/**
 * Takes an array and turns it into a stream that uses the chunker
 */
class ChunkedArrayStream {
	constructor(array = [], opts = {}) {
		this._stream = arrayStream(array)
		// don't use node's streams v3 internal buffer because
		// the chunker will buffer for us
		this._stream.pause = _.noop
		this._chunker = new Chunker(this._stream, opts)
	}

	chunker() {
		return this._chunker
	}

	start() {
		this._stream.pipe(this._chunker)
	}
}

export default ChunkedArrayStream
ChunkedArrayStream.__filename__ = 'reports/common/chunked-array-stream.js'
